import _ from 'underscore';

import View from './view';





export default View.extend( {

    setLocations(locations) {
        this.locations_ = locations;
        return this.render();
    },

    clearLocations() {
        return this.setLocations( null );
    },

    events: {
        'click .glyphicon-remove': function() {
            this.clearLocations();
        }
    },

    onBind(model) {
        this.listenTo( model, 'change:point', 
            () => this.render() );
        this.listenTo( model, 'change:type_id',
            () => this.render() );
        this.listenTo( model, 'change:assigned_organization_id',
            () => this.render() );
        this.listenTo( model, 'change:assigned_user_id', 
            () => this.render() );
    },

    serialize() {
        const { locationService, height } = this.options;

        if (this.locations_)
            return {
                mapUsers: this.locations_.filter( loc => !!loc.is_active ),
                zonesInactive: true,
                locationService,
                height,
            };

        return { locationService, };
    },

    [View.event( 'Map:assignee:click' )]() {
        if (!this.Map.disabled())
            this.trigger( 'assignee:click' );
    },

    [View.event( 'Map:assignee:assign' )](user) {
        if (!this.Map.disabled())
            this.trigger( 'assignee:assign', user );
    },

    [View.event( 'Map:map:click' )](location) {
        if (!this.Map.disabled())
            this.trigger( 'map:click', location );
    },

    [View.event( 'Map:service-object:choose' )](serviceObjectAttrs) {
        if (!this.Map.disabled())
            this.trigger( 'map:click', serviceObjectAttrs.coords );
    },

    [View.event( 'Map:address:choose' )](addressAttrs) {
        if (!this.Map.disabled())
            this.trigger( 'map:click', addressAttrs.coords );
    },

} );



// WEBPACK FOOTER //
// ./src/js/view/map.assignees.js